<template>
  <div class="fb-promo" v-if="tokens.length > 0">
    <div class="fb-promo__head">
      <svg class="fb-promo__gift" viewBox="0 0 64 64" width="52" height="52" aria-hidden="true">
        <defs>
          <linearGradient id="fbPromoBox" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#ff4d8d"/>
            <stop offset="1" stop-color="#ff8a3d"/>
          </linearGradient>
          <linearGradient id="fbPromoLid" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#ff6aa3"/>
            <stop offset="1" stop-color="#ffa45c"/>
          </linearGradient>
        </defs>
        <g class="fb-promo__sparkles" fill="#ffd23f">
          <path d="M8 14l1.5 3.5L13 19l-3.5 1.5L8 24l-1.5-3.5L3 19l3.5-1.5z"/>
          <path d="M56 6l1 2.5 2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z"/>
          <circle cx="58" cy="26" r="1.8"/>
        </g>
        <rect x="12" y="30" width="40" height="28" rx="4" fill="url(#fbPromoBox)"/>
        <rect x="9" y="22" width="46" height="11" rx="3" fill="url(#fbPromoLid)"/>
        <rect x="28" y="22" width="8" height="36" fill="#ffd23f"/>
        <path d="M32 22c-4-9-14-11-14-4 0 4 7 5 14 4z" fill="#ffd23f"/>
        <path d="M32 22c4-9 14-11 14-4 0 4-7 5-14 4z" fill="#ffc107"/>
      </svg>

      <div class="fb-promo__body">
        <span class="fb-promo__title">{{ $tc('cartSheet.freeBetsTitle', tokens.length, { count: tokens.length }) }}</span>
        <span class="fb-promo__text" v-html="$t('cartSheet.freeBetsText', { amount: totalLabel })"></span>
      </div>
    </div>

    <button type="button" class="fb-promo__cta" @click="showModal = true">
      <span>{{ $t('freeBets.showAll', { count: tokens.length }) }}</span>
      <v-icon small>mdi-chevron-right</v-icon>
    </button>

    <FreeBetsModal v-model="showModal" :selectable="false"></FreeBetsModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import freeBetInfoMixin from "@/mixins/freeBetInfoMixin";
import FreeBetsModal from "@/components/right_widgets/FreeBetsModal";

export default {
  name: "FreeBetsPromo",
  components: { FreeBetsModal },
  mixins: [freeBetInfoMixin],
  data: () => ({
    showModal: false,
  }),
  computed: {
    ...mapGetters({
      getSettings: "cart/getSettings",
      getAuthenticated: "user/getAuthenticated",
      getAvailableFreeBets: "cart/getAvailableFreeBets",
    }),
    tokens() {
      return Array.isArray(this.getAvailableFreeBets) ? this.getAvailableFreeBets : [];
    },
    totalLabel() {
      const total = this.tokens.reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
      const currency = (this.tokens[0] && this.tokens[0].currency) || this.getSettings.currency || '';
      return `${this.formatFreeBetAmount(total)} ${currency}`.trim();
    },
  },
  watch: {
    getAuthenticated(val) {
      if (val) this.loadIfNeeded();
    },
  },
  mounted() {
    this.loadIfNeeded();
  },
  methods: {
    ...mapActions({
      fetchAvailableFreeBets: "cart/fetchAvailableFreeBets",
    }),
    loadIfNeeded() {
      if (this.getAuthenticated && this.getAvailableFreeBets === null) {
        this.fetchAvailableFreeBets();
      }
    },
  },
};
</script>

<style scoped>
.fb-promo {
  position: relative;
  width: 100%;
  margin-top: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  text-align: left;
  overflow: hidden;
  /* Palette rosa / arancio / oro della prima versione */
  background:
      linear-gradient(135deg, rgba(255, 77, 141, 0.16), rgba(255, 138, 61, 0.12) 55%, rgba(255, 210, 63, 0.08)),
      var(--bg-card);
  border: 1px solid rgba(255, 106, 163, 0.35);
}

.fb-promo__head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.fb-promo__gift {
  flex-shrink: 0;
  animation: fbGiftWiggle 2.8s ease-in-out infinite;
  transform-origin: 50% 90%;
}

.fb-promo__sparkles {
  animation: fbSparkle 1.6s ease-in-out infinite alternate;
}

.fb-promo__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.fb-promo__title {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--text-platform);
}

.fb-promo__text {
  font-size: var(--font-size-2xl);
  line-height: 1.45;
  color: var(--text-op-50-platform);
}

.fb-promo__text >>> u {
  color: #ffb36b;
  font-weight: 700;
  text-decoration: none;
}

.fb-promo__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  margin-top: 12px;
  padding: 9px 12px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #ff4d8d, #ff8a3d);
  color: #fff;
  font-size: var(--font-size-2xl);
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.15s, transform 0.1s;
}

.fb-promo__cta:hover {
  filter: brightness(1.08);
}

.fb-promo__cta:active {
  transform: scale(0.98);
}

.fb-promo__cta .v-icon {
  color: inherit;
}

@keyframes fbGiftWiggle {
  0%, 70%, 100% { transform: rotate(0deg); }
  76% { transform: rotate(-7deg); }
  82% { transform: rotate(6deg); }
  88% { transform: rotate(-4deg); }
  94% { transform: rotate(2deg); }
}

@keyframes fbSparkle {
  from { opacity: 0.45; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .fb-promo__gift,
  .fb-promo__sparkles {
    animation: none;
  }
}
</style>
